import arrayMove from 'array-move';
import async from 'async';
import classNames from 'classnames/bind';
import serialize from 'form-serialize';
import { isEqual } from 'lodash-es';
import React, { Component } from 'react';
import { DiceRoll } from '@dice-roller/rpg-dice-roller';
import {
  Button, Col, Form, ListGroup, Modal, Row, Spinner,
} from 'react-bootstrap';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { showToast } from 'components/ui/utils';
import { StepTypeMode } from '../../../../dorian-shared/types/branch/Branch';
import {
  BranchStepMemoryActionType,
  BranchStepMemoryRollType,
  StepTypes,
} from '../../../../dorian-shared/types/branch/BranchStep';
import { noop } from '../../../../helpers/noop';
import { api } from '../../../api';
import { ErrorAlert } from '../../../ui/Errors/ErrorAlet';
import { isDecisionStep, isStepTypeIdExist } from '../../../utils/branchUtils';
import {
  getMemorySlotVariableLink,
  isMemorySlotVariableLink,
  parseMemorySlotVariableLink,
} from '../../../utils/choiceMemoryUtils';
import { validateHubStep } from './Steps/StepTypeHub/hubValidation';
import { sanitizeCheckStepValue } from './Steps/checkStepValidation';
// eslint-disable-next-line import/no-cycle
import { PremiumIpDisabledApprovedEdit } from '../../../utils/premiumIpDisabledApprovedEdit';
import { PremiumIpDisabledEdit } from '../../../utils/premiumIpDisabledEdit';
import {
  CheckOperator,
  MemoryCheckValueType,
  MemoryShowIn,
  MemoryType,
} from '../../Book/MemoryBank/memoryBankTypes';
import { CustomSelect } from '../CustomSelect';
import { AddBranchHead } from './AddBranchHead';
import { AddStep } from './AddStep';
import { BranchModalPrevNext } from './BranchModalPrevNext';
import { ContextProvider } from './context/ContextProvider';
import { EliminationAnswerResultType } from './Steps/AnswerEliminationType';
import { clearStepData, getStepData, prepareForCopy } from './Steps/CopyPastStep';
import styles from './Steps/Steps.scss';
import { StepsFormContextWrapper } from './Steps/StepsFormContextWrapper';
import { SWITCH_INDEX_TYPE } from './Steps/StepTypeCheck/StepTypeCheckSwitchForm';
import { collectExistingTitles } from './utils/collectExistingTitles';
import { enrichArrWithBranchTitles } from './utils/enrichArrWithBranchTitles';
import {
  deserializeHubOptionFromApi,
  prepareHubOptionForSave,
  deserializeHubSettingsFromApi,
  prepareHubSettingsForSave,
} from './Steps/StepTypeHub/hubOptionTransform';
import {
  describeStep,
  findUnresolvedBackgrounds,
  findVideoBackgroundConflicts,
  hasNewBackgroundDataRow,
  preserveUnrenderedStepText,
  mergeStepBackgrounds,
} from './Steps/stepDataFields';
import { RememberActionType } from './Steps/StepTypeRemember';
import {
  checkUsedMemoriesInText,
  count,
  isGamePassAchievement,
  SCROLLABLE_STEP_FORM_ELEMENT_ID,
} from './Steps/utils';
import { convertBranchToForm } from './convertBranchToForm';
import { FEATURE_NODE_EDIT_SIDE_PANEL } from '../../../../helpers/featureFlags';

const cs = classNames.bind(styles);

const SortableItemSteps = SortableElement(({ object, i, ...props }) => (
  <StepsFormContextWrapper
    step={object}
    index={i}
    {...props}
  />
));

const SortableListSteps = SortableContainer(({ items, disabledSortable, ...props }) => (
  <ListGroup as="ol" start="0" variant="flush" className="my-1 ml-4 mr-1 branchesList">
    {items.map((value, index) => (
      <SortableItemSteps
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        disabled={!!disabledSortable}
        index={index}
        object={value}
        i={index}
        {...props}
      />
    ))}
  </ListGroup>
));

// eslint-disable-next-line no-return-assign,no-void,no-cond-assign,no-param-reassign
const replacer = (k, v) => (Array.isArray(v) && !(v = v.filter((e) => e)).length ? void 0 : v);

export class AddBranch extends Component {
  constructor(...args) {
    super(...args);
    const { data } = this.props;

    this.state = {
      validated: false,
      locations: [],
      locationId: '',
      steps: [],
      stepConst: [],
      stepsType: [],
      characters: [],
      characterExpression: [],
      tagsTypes: [],
      // eslint-disable-next-line react/no-unused-state
      addStep: false,
      // eslint-disable-next-line react/no-unused-state
      analytics: null,
      loading: false,
      errorMsg: null,
      saveLoading: false,
      activeSteps: null,
      addLoading: false,
      choice: false,
      isCheckStep: false,
      isHubStep: false,
      gotoBranchId: data ? data.gotoBranchId : '',
      modalPrev: false,
      modalNext: false,
      defaultValueTitle: data ? data.title : 'NewNode',
      defaultValueDescription: data ? data.description || '' : 'Description',
      statsInfo: {},
      currStatsInfo: {},
      ending: false,
      result: false,
      disabledSortable: false,
      editHeader: false,
      SelectStepsCopy: false,
      copyStep: [],
      allCopyStepChecked: false,
      deleteStep: [],
      SelectStepsDelete: false,
      allDeleteStepChecked: false,
      stepTypeMode: null,
      audioPath: null,
    };
    this.formRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (FEATURE_NODE_EDIT_SIDE_PANEL) {
      const updates = {};
      if (prevProps.globalContext?.bookCharacters !== this.props.globalContext?.bookCharacters) {
        updates.characters = this.props.globalContext?.bookCharacters ?? [];
      }
      if (prevProps.globalContext?.bookLocations !== this.props.globalContext?.bookLocations) {
        updates.locations = this.props.globalContext?.bookLocations ?? [];
      }
      if (Object.keys(updates).length > 0) {
        this.setState(updates);
      }

      if (prevProps.data?.id !== this.props.data?.id) {
        this.loadData();
      }
    }

    const { edit, addBranchEdit, data } = this.props;
    const {
      gotoBranchId, steps, copyStep, editHeader, stepConst,
    } = this.state;

    if (steps !== prevState.steps) {
      steps.forEach((step, i) => {
        // eslint-disable-next-line no-param-reassign
        step.ind = i;
      });
    }
    const copyStepFromStorage = JSON.parse(localStorage.getItem('copyStep'));
    if (JSON.stringify(copyStepFromStorage) !== JSON.stringify(copyStep)) {
      this.setState({
        copyStep: copyStepFromStorage,
      });
    }
    if (
      JSON.stringify(prevState.steps) !== JSON.stringify(steps)
      || prevState.editHeader !== editHeader
      || Number(prevState.gotoBranchId) !== Number(gotoBranchId)
    ) {
      const isStepsEqual = isEqual(steps, stepConst);

      const newEdit = !isStepsEqual
        || editHeader
        || Number(gotoBranchId) !== Number(data.gotoBranchId);
      if (newEdit !== addBranchEdit) {
        edit(newEdit);
      }
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.stepTypes !== state.stepsType) {
      return { stepsType: props.stepTypes };
    }
    return null;
  }

  defStepType() {
    const { result, ending } = this.state;

    if (result) {
      return 5;
    } if (ending) {
      return 5;
    }
    return 1;
  }

  disabledSortableAction = (val) => {
    this.setState({
      disabledSortable: val,
    });
  };

  errorAlert = (error) => {
    this.setState({
      errorMsg: error,
    });
    setTimeout(() => {
      this.errorAlertClose();
    }, 3000);
  };

  errorAlertClose = () => {
    this.setState({
      errorMsg: null,
    });
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    const { steps } = this.state;

    const newSteps = arrayMove(steps, oldIndex, newIndex);
    this.setState({
      steps: newSteps,
      activeSteps: `step-${newIndex}`,
    });
    this.props.cursorEvents?.stepMoved(oldIndex, newIndex, newSteps);
  };

  updateSteps = (index, value) => {
    const { steps } = this.state;

    const newSteps = steps.slice();
    newSteps[index] = value;
    this.setState({
      steps: newSteps,
      ...this.getCheckChoiceStates(newSteps),
    }, this.updateStats());
    // newSteps is passed raw — the wrapper builds the draft snapshot with fresh props.data.
    this.props.cursorEvents?.stepEdited(index, newSteps);
  };

  handleChangeSteps = (value, stepIndex, key) => {
    const { steps } = this.state;
    const stepsCopy = steps.slice();
    const obj = {
      [key]: value,
    };
    stepsCopy[stepIndex] = { ...stepsCopy[stepIndex], ...obj };

    let stepTypeId = Number(stepsCopy[stepIndex].stepTypeId);
    if (stepTypeId !== StepTypes.Remember) {
      this.removeStepAction(stepsCopy[stepIndex]);
    }

    if (stepTypeId !== StepTypes.Random) {
      this.removeStepRoll(stepsCopy[stepIndex]);
    }

    if (stepTypeId !== StepTypes.Check) {
      this.removeStepCheck(stepsCopy[stepIndex]);
    }

    this.setState({
      steps: stepsCopy,
      ...this.getCheckChoiceStates(stepsCopy),
    });
    // newSteps is passed raw — the wrapper builds the draft snapshot with fresh props.data.
    this.props.cursorEvents?.stepEdited(stepIndex, stepsCopy);
  };

  addStepObject = (stepIndex, objectName, newObject) => {
    const { steps } = this.state;
    const stepCopy = { ...steps[stepIndex] };

    stepCopy[objectName] = newObject;
    this.updateSteps(stepIndex, stepCopy);
  };

  removeStepObject = (step, objectNames) => {
    if (!objectNames) {
      return;
    }

    for (let i = 0; i < objectNames.length; i++) {
      const objectName = objectNames[i];
      if (step[objectName]) {
        // eslint-disable-next-line no-param-reassign
        delete step[objectName];
      }
    }
  };

  handleChangeStepObject = (objectName, values, stepIndex) => {
    const { steps } = this.state;
    const stepCopy = { ...steps[stepIndex] };
    // Check if there's a 'value' field in the values array (for MemoryLinkValue)
    const valueField = values.find((v) => v.name === 'value');
    const value = valueField ? valueField.value : values[0].value;
    // Check if there's a variableId being set
    const variableIdField = values.find((v) => v.name === 'variableId');

    // TODO: REWORK THIS
    if (objectName === 'check') {
      const { check } = stepCopy;
      const operator = CheckOperator[check.operator];
      const isMultiSelect = operator?.isMultiSelect ?? false;
      const isConditionList = operator?.isConditionList ?? false;

      // Handle ConditionList variable selection (just variableId, no MemoryLinkValue)
      if (isConditionList && variableIdField && !valueField) {
        // For ConditionList, initialize with 2 conditions if selecting a variable
        if (!stepCopy.switch || stepCopy.switch.length === 0) {
          stepCopy.switch = [
            { gotoBranchId: 0, operator: '=', intValue: '' },
            { gotoBranchId: 0 },  // Last row doesn't have operator/intValue
          ];
        }
      }

      const isMemoryLink = isMemorySlotVariableLink(value);
      if (isMemoryLink) {
        if (isMultiSelect) {
          stepCopy.switch = value.variableId.map((variableId) => {
            const existingValue = stepCopy.switch?.find((sw) => sw.value === variableId);
            if (existingValue) {
              return existingValue;
            }
            return {
              value: variableId,
              gotoBranchId: 0,
            };
          });
        }
      }

      // Handle operator change
      const operatorChangeValue = values.find((v) => v.name === 'operator');
      if (operatorChangeValue) {
        const oldOperator = CheckOperator[check.operator];
        const newOperator = CheckOperator[operatorChangeValue.value];
        const wasConditionList = oldOperator?.isConditionList ?? false;
        const isNewConditionList = newOperator?.isConditionList ?? false;
        const wasMultiSelect = oldOperator?.isMultiSelect ?? false;
        const isNewMultiSelect = newOperator?.isMultiSelect ?? false;
        const wasPlayerHas = oldOperator?.isPlayerHas ?? false;
        const isNewPlayerHas = newOperator?.isPlayerHas ?? false;

        // Clear variables and rows when switching between ConditionList and Lowest/Highest
        const switchingFromConditionListToMultiSelect = wasConditionList && isNewMultiSelect;
        const switchingFromMultiSelectToConditionList = wasMultiSelect && isNewConditionList;

        // Handle switching to/from PlayerHas
        const switchingToPlayerHas = !wasPlayerHas && isNewPlayerHas;
        const switchingFromPlayerHas = wasPlayerHas && !isNewPlayerHas;

        if (switchingFromConditionListToMultiSelect) {
          // Switching from ConditionList to Lowest/Highest: clear everything
          stepCopy.check = {
            operator: operatorChangeValue.value,
            value: {
              type: 'variable[]',
              variableId: [],
            },
          };
          delete stepCopy.check.variableId;
          stepCopy.switch = [];
        } else if (switchingFromMultiSelectToConditionList) {
          // Switching from Lowest/Highest to ConditionList: clear everything
          stepCopy.check = {
            operator: operatorChangeValue.value,
          };
          delete stepCopy.check.value;
          delete stepCopy.check.variableId;
          stepCopy.switch = [];
        } else if (switchingToPlayerHas) {
          // Switching TO PlayerHas from any other operator: clear everything and set empty value
          stepCopy.check = {
            operator: operatorChangeValue.value,
            value: [],
            variableId: 0,
            match: 'all',
          };
          stepCopy.switch = [];
        } else if (switchingFromPlayerHas && isNewMultiSelect) {
          // Switching FROM PlayerHas to Lowest/Highest: clear everything and set up variable array
          stepCopy.check = {
            operator: operatorChangeValue.value,
            value: {
              type: 'variable[]',
              variableId: [],
            },
          };
          delete stepCopy.check.variableId;
          stepCopy.switch = [];
        } else if (switchingFromPlayerHas && isNewConditionList) {
          // Switching FROM PlayerHas to ConditionList: clear everything
          stepCopy.check = {
            operator: operatorChangeValue.value,
          };
          delete stepCopy.check.value;
          delete stepCopy.check.variableId;
          stepCopy.switch = [];
        } else if (isNewConditionList && !wasConditionList) {
          // Switching to ConditionList from a regular check: initialize with 2 conditions
          stepCopy.switch = [
            { value: 'condition_0', gotoBranchId: 0 },
            { value: 'condition_1', gotoBranchId: 0 },
          ];
          // Keep existing variableId if present
          if (check.variableId) {
            stepCopy.check = {
              ...check,
              operator: operatorChangeValue.value,
            };
            delete stepCopy.check.value;
          }
        }
      }
    }

    let tempObj = {};
    if (stepCopy[objectName]) {
      tempObj = { ...stepCopy[objectName] };
    }

    values.forEach((valueObj) => {
      tempObj[valueObj.name] = valueObj.value;
    });
    stepCopy[objectName] = tempObj;
    this.updateSteps(stepIndex, stepCopy);
  };

  addStepAction = (stepIndex, variableId, variable, type, value) => {
    const actionObj = {
      variableId, variable, type, value,
    };
    this.addStepObject(stepIndex, 'action', actionObj);
  };

  removeStepAction = (step) => {
    this.removeStepObject(step, ['action']);
  };

  handleChangeStepAction = (values, stepIndex) => {
    this.handleChangeStepObject('action', values, stepIndex);
  };

  addStepRoll = (stepIndex, variableId, variable, type, min, max, modifier, diceNotation) => {
    const rollObj = {
      variableId, variable, type,
    };

    // Add min/max for non-DICE types or diceNotation for DICE type
    if (type === 'dice') {
      rollObj.diceNotation = diceNotation;
    } else {
      rollObj.min = min;
      rollObj.max = max;
    }

    // Only include modifier if it's provided and not empty
    if (modifier !== undefined && modifier !== null && modifier !== '') {
      rollObj.modifier = modifier;
    }

    this.addStepObject(stepIndex, 'roll', rollObj);
  };

  removeStepRoll = (step) => {
    this.removeStepObject(step, ['roll']);
  };

  handleChangeStepRoll = (values, stepIndex) => {
    this.handleChangeStepObject('roll', values, stepIndex);
  };

  addStepCheck = (stepIndex, variableId, operatorName, value) => {
    const checkObj = {
      variableId: Number(variableId), operator: operatorName, value,
    };
    this.addStepObject(stepIndex, 'check', checkObj);
  };

  removeStepCheck = (step) => {
    this.removeStepObject(step, ['check', 'switch']);
  };

  handleChangeStepCheck = (values, stepIndex) => {
    this.handleChangeStepObject('check', values, stepIndex);
  };

  handleChangeStepSwitch = (gotoBranchId, stepIndex, switchIndex) => {
    const { steps } = this.state;
    const stepData = { ...steps[stepIndex] };

    const switchValues = stepData.switch ? [...stepData.switch] : [];

    const isMultiSelect = CheckOperator[stepData.check.operator]?.isMultiSelect ?? false;
    const isConditionList = CheckOperator[stepData.check.operator]?.isConditionList ?? false;

    if (!switchValues[SWITCH_INDEX_TYPE.TRUE] && !isMultiSelect && !isConditionList) {
      switchValues[SWITCH_INDEX_TYPE.TRUE] = {
        value: true,
        gotoBranchId: 0,
      };
    }
    if (!switchValues[SWITCH_INDEX_TYPE.FALSE] && !isMultiSelect && !isConditionList) {
      switchValues[SWITCH_INDEX_TYPE.FALSE] = {
        value: false,
        gotoBranchId: 0,
      };
    }

    switchValues[switchIndex].gotoBranchId = gotoBranchId;
    stepData.switch = switchValues;
    this.updateSteps(stepIndex, stepData);
  };

  handleAddStepSwitchCondition = (stepIndex) => {
    const { steps } = this.state;
    const stepData = { ...steps[stepIndex] };

    const switchValues = stepData.switch ? [...stepData.switch] : [];

    // Insert new condition BEFORE the last row (which is the "Otherwise" row)
    // The last row should remain as "Otherwise" with no operator/intValue
    const insertIndex = switchValues.length - 1;

    // Insert new condition with operator/intValue (frontend format)
    switchValues.splice(insertIndex, 0, {
      gotoBranchId: 0,
      operator: 'equal',
      intValue: '', // Frontend format
    });

    stepData.switch = switchValues;
    this.updateSteps(stepIndex, stepData);
  };

  handleRemoveStepSwitchCondition = (stepIndex, switchIndex) => {
    const { steps } = this.state;
    const stepData = { ...steps[stepIndex] };

    const switchValues = stepData.switch ? [...stepData.switch] : [];

    // Remove the condition at the specified index
    if (switchValues.length > 2) {  // Minimum 2 conditions
      switchValues.splice(switchIndex, 1);
      stepData.switch = switchValues;
      this.updateSteps(stepIndex, stepData);
    }
  };

  handleReorderStepSwitchConditions = (stepIndex, oldIndex, newIndex) => {
    const { steps } = this.state;
    const stepData = { ...steps[stepIndex] };

    const switchValues = stepData.switch ? [...stepData.switch] : [];

    // Reorder the conditions (arrayMove handles the reordering)
    stepData.switch = arrayMove(switchValues, oldIndex, newIndex);
    this.updateSteps(stepIndex, stepData);
  };

  handleChangeStepSwitchCondition = (operator, intValue, stepIndex, switchIndex) => {
    const { steps } = this.state;
    const stepData = { ...steps[stepIndex] };

    const switchValues = stepData.switch ? [...stepData.switch] : [];

    if (switchValues[switchIndex]) {
      switchValues[switchIndex] = {
        ...switchValues[switchIndex],
        operator, // Already in word format ('equal', 'less', 'greater')
        intValue, // Frontend format
        varValue: undefined, // Clear varValue when setting intValue
      };
      // Remove varValue from the object if it exists
      delete switchValues[switchIndex].varValue;
    }

    stepData.switch = switchValues;
    this.updateSteps(stepIndex, stepData);
  };

  handleChangeStepSwitchVariableCondition = (operator, varValue, stepIndex, switchIndex) => {
    const { steps } = this.state;
    const stepData = { ...steps[stepIndex] };

    const switchValues = stepData.switch ? [...stepData.switch] : [];

    if (switchValues[switchIndex]) {
      switchValues[switchIndex] = {
        ...switchValues[switchIndex],
        operator, // Already in word format ('equal', 'less', 'greater')
        varValue, // Frontend format
        intValue: undefined, // Clear intValue when setting varValue
      };
      // Remove intValue from the object if it exists
      delete switchValues[switchIndex].intValue;
    }

    stepData.switch = switchValues;
    this.updateSteps(stepIndex, stepData);
  };

  addStep = (index, obj, replace) => {
    const { steps } = this.state;
    const newSteps = steps.slice();
    const { data } = this.props;

    const newStep = obj || {
      id: '',
      stepTypeId: this.defStepType(),
      text: null,
      characterId: null,
      characterRelationship: null,
      characterExpressionId: null,
      branchId: data.id,
      answers: [],
      data: [],
    };
    if (index !== undefined) {
      if (replace) {
        newSteps.splice(index, 1, newStep);
      } else {
        newSteps.splice(index + 1, 0, newStep);
      }
    } else {
      newSteps.push(newStep);
    }
    const insertedAt = index !== undefined ? index + 1 : newSteps.length - 1;
    this.setState({
      activeSteps: `step-${insertedAt}`,
      steps: newSteps,
      ...this.getCheckChoiceStates(newSteps),
    });
    if (replace) {
      // Paste overwrites step data — signal the edit stream so the emulator reflects
      // the replaced content without waiting for the next field edit.
      this.props.cursorEvents?.stepEdited(index, newSteps);
    } else {
      this.props.cursorEvents?.stepAdded(insertedAt, newSteps);
    }
  };

  deleteStep = (i) => {
    const newSteps = [];
    const { steps } = this.state;
    steps.forEach((a, index) => {
      if (!i.includes(index)) {
        newSteps.push(a);
      }
    });
    this.setState({
      steps: newSteps,
      deleteStep: [],
      SelectStepsDelete: false,
      allDeleteStepChecked: false,
      ...this.getCheckChoiceStates(newSteps),
    });
    this.props.cursorEvents?.stepsDeleted(i, newSteps);
  };

  activeSteps = (arg) => {
    this.setState({
      activeSteps: arg,
    });
  };

  updateStats = () => {
    const { steps, statsInfo, currStatsInfo } = this.state;
    const newStatsInfo = { ...statsInfo };
    steps.forEach((el) => {
      if (Number(el.stepTypeId) === 3) {
        el.answers.forEach((ans) => {
          ans.requires.forEach((req) => {
            newStatsInfo[Number(req.requireTypeId)] += 1;
          });
        });
      }
    });
    if (JSON.stringify(newStatsInfo) !== JSON.stringify(currStatsInfo)) {
      this.setState({
        currStatsInfo: newStatsInfo,
      });
    }
  };

  initEditBranch = (val) => {
    const { modalNext, modalPrev } = this.state;

    if (val === 'prev') {
      this.setState({
        modalPrev: !modalPrev,
      });
    }
    if (val === 'next') {
      this.setState({
        modalNext: !modalNext,
      });
    }
  };

  actionEditBranch = (val) => {
    const { onHide, actionEditBranch } = this.props;

    onHide();
    setTimeout(() => {
      actionEditBranch(val);
    }, 50);
  };

  componentDidMount() {
    const { data, onSaveTriggerReady } = this.props;

    // Hand the parent a way to start a save without a cross-component ref: save is a
    // native form submit (serialize reads the form DOM), so requestSubmit on the form's
    // own ref is the trigger. Parent stores this fn and calls it for "Save and continue".
    onSaveTriggerReady?.(() => this.formRef.current?.requestSubmit());

    if (data !== null && data.id) {
      this.loadData();
    }

    if (data === null || !data.id) {
      this.addStories(data || {}, true);
    }
  }

  reLoadCharacters = () => {
    const { storyId } = this.props;

    if (FEATURE_NODE_EDIT_SIDE_PANEL) {
      const {
        globalContext,
        story,
      } = this.props;
      /** @type {(bookId: number) => Promise<void>} */
      globalContext.fetchBookCharacters(story.book.id);
      return;
    }

    api.get(`/v1/stories/${storyId}/characters`)
      .then((res) => {
        this.setState({
          characters: res.data.characters,
        });
      })
      .catch((error) => {
        this.errorAlert(error);
      });
  };

  loadData() {
    const { story, storyId, data } = this.props;
    this.setState({
      loading: true,
    });

    async.parallel({
      ...(FEATURE_NODE_EDIT_SIDE_PANEL ? {} : {
        locations: (callback) => {
          api.get(`/v1/books/${story.book.id}/locations`)
            .then((res) => {
              callback(null, res.data.locations);
            }).catch((error) => {
              callback(error, null);
            });
        },
        characters: (callback) => {
          api.get(`/v1/stories/${storyId}/characters`)
            .then((res) => {
              callback(null, res.data.characters);
            }).catch((error) => {
              callback(error, null);
            });
        },
        expressions: (callback) => {
          api.get('/v1/characters/expressions')
            .then((res) => {
              callback(null, res.data.expressions);
            }).catch((error) => {
              callback(error, null);
            });
        },
      }),
      tags: (callback) => {
        api.get('/v1/answers/tags/types')
          .then((res) => {
            callback(null, res.data.types);
          }).catch((error) => {
            callback(error, null);
          });
      },
      branchData: (callback) => {
        if (data.id) {
          if (FEATURE_NODE_EDIT_SIDE_PANEL) {
            // Flag ON: node was refreshed by revalidateAndOpenBranch (index.js) before
            // the form opened. Use props.data directly — links_from/links_to are already
            // attached. Skips GET /v1/stories/:id/branches/:id entirely.
            callback(null, data);
          } else {
            api.get(`/v1/stories/${storyId}/branches/${data.id}`)
              .then((res) => {
                callback(null, res.data.branch);
              }).catch((error) => {
                callback(error, null);
              });
          }
        } else {
          callback(null, null);
        }
      },
    }, (err, res) => {
      try {
        // props.data may have changed while the tags request was in flight (rapid node
        // switches). A fresh loadData() is already running — discard this stale result.
        if (this.props.data?.id !== data?.id) {
          return;
        }
        if (err) {
          this.errorAlert(err);
        } else {
          // statsInfo reads raw steps before any conversion (step ids/types are stable).
          const statsInfo = {};
          res.branchData.steps.forEach((step) => {
            if (step.stepTypeId === 3) {
              step.answers.forEach((ans) => {
                ans.requires.forEach((req) => {
                  statsInfo[req.requireTypeId] -= 1;
                });
              });
            }
          });

          const { memoryBank, audios } = this.props;

          let steps;
          let stepTypeMode;
          let locationId;
          let analytics;
          let audioPath;
          let hadSanitized = false;

          if (FEATURE_NODE_EDIT_SIDE_PANEL) {
            // Flag ON: cache → form conversion (no in-place mutation, audioPath derived).
            ({
              steps,
              stepTypeMode,
              locationId,
              analytics,
              audioPath,
              hadSanitized,
            } = convertBranchToForm(res.branchData, memoryBank ?? [], audios ?? []));
          } else {
            // Flag OFF: original inline path — behaviour preserved byte-for-byte so the
            // feature can be rolled back in prod by disabling the flag. Mutates the
            // branchData steps in place exactly as before. Type-list lift is NOT gated
            // (treated as a pre-existing change) and feeds setState below regardless.
            steps = res.branchData?.steps != null ? res.branchData.steps : [];
            stepTypeMode = res.branchData?.stepTypeMode ?? StepTypeMode.Regular;

            // Transform backend format to frontend format for ConditionList conditions
            steps.forEach((step) => {
              if (step.check && step.check.operator === 'conditionList') {
                // Ensure top-level variableId is a number
                if (step.check.variableId !== undefined) {
                  step.check.variableId = Number(step.check.variableId);
                }

                // Transform switch conditions
                if (step.switch) {
                  step.switch = step.switch.map((switchItem) => {
                    const transformed = { ...switchItem };

                    // Ensure gotoBranchId is a number
                    if (transformed.gotoBranchId !== undefined) {
                      transformed.gotoBranchId = Number(transformed.gotoBranchId);
                    }

                    // Map 'number' to 'intValue' for frontend (ensure it's a string for text input)
                    if (transformed.number !== undefined) {
                      transformed.intValue = String(transformed.number);
                      delete transformed.number;
                    }

                    // Map 'variable' to 'varValue' for frontend (convert string to number)
                    if (transformed.variable !== undefined) {
                      transformed.varValue = Number(transformed.variable);
                      delete transformed.variable;
                    }

                    return transformed;
                  });
                }
              }
            });

            // Sanitize invalid check step values from legacy data
            if (memoryBank && memoryBank.length > 0) {
              steps.forEach((step) => {
                if (step.check && sanitizeCheckStepValue(step.check, memoryBank)) {
                  hadSanitized = true;
                }
              });
            }

            // Deserialize hub mods → frontend condition arrays (V1.0+ adds logic here)
            steps.forEach((step) => {
              if (step.hubSettings) {
                deserializeHubSettingsFromApi(step.hubSettings);
              }
              if (step.hubOptions) {
                step.hubOptions.forEach((opt) => {
                  deserializeHubOptionFromApi(opt);
                });
              }
            });

            locationId = res.branchData && res.branchData.locationId !== null
              ? Number(res.branchData.locationId)
              : '';
            analytics = res.branchData && res.branchData.analytics ? res.branchData.analytics : null;
            audioPath = res.branchData?.audioPath ?? null;
          }

          // Toast for sanitized check steps is a UI side effect — stays here, not in converter.
          if (hadSanitized) {
            showToast({
              textMessage: 'Some check steps had invalid values for their variable type. These values were cleared — please re-enter the correct values.',
              variant: 'warning',
              timeout: 7000,
            });
          }

          this.setState({
            /** @type {Character[]} */
            characters: FEATURE_NODE_EDIT_SIDE_PANEL ? (this.props.globalContext?.bookCharacters ?? []) : res.characters,
            /** @type {BookLocation[]} */
            locations: FEATURE_NODE_EDIT_SIDE_PANEL ? (this.props.globalContext?.bookLocations ?? []) : res.locations,
            /** @type {ExpressionConfig[]} */
            characterExpression: FEATURE_NODE_EDIT_SIDE_PANEL ? (this.props.globalContext?.expressions ?? []) : res.expressions,
            tagsTypes: res.tags,
            steps,
            stepConst: steps.map((step) => ({
              ...step,
              data: Array.isArray(step.data) ? step.data.map((row) => ({ ...row })) : step.data,
            })),
            locationId,
            analytics,
            addStep: false,
            loading: false,
            data: res.branchData,
            defaultValueTitle: res.branchData?.title ?? 'NewNode',
            gotoBranchId: res.branchData?.gotoBranchId ?? '',
            editHeader: false,
            validated: false,
            statsInfo,
            currStatsInfo: {},
            stepTypeMode,
            audioPath,
            ...this.getCheckChoiceStates(steps),
          });

          // Focus on the text step if possible
          const { editStepId } = data;
          if (editStepId) {
            const stepIndex = steps.findIndex((step) => step.id === editStepId);
            if (stepIndex !== -1) {
              const stepTextElement = document.getElementById(`stepText-${stepIndex}`);
              if (stepTextElement) {
                stepTextElement.focus();
              }
            }
          }
        }
      } catch (e) {
        this.errorAlert(e);
      }
    });
  }

  updateLocation = () => {
    const { story } = this.props;

    if (FEATURE_NODE_EDIT_SIDE_PANEL) {
      /** @type {(bookId: number) => Promise<void>} */
      this.props.globalContext.fetchBookLocations(story.book.id);
      return;
    }

    api.get(`/v1/books/${story.book.id}/locations`)
      .then((res) => {
        this.setState({
          locations: res.data.locations,
        });
      });
  };

  addStories(arr, validated) {
    const {
      lastLocation,
      update,
      data,
      storyId,
      onError,
      onLocationSelected,
      onBranchUpdate,
      onBranchCreate,
      globalContext,
    } = this.props;

    // eslint-disable-next-line no-param-reassign
    arr = JSON.parse(JSON.stringify(arr, replacer, 2));

    if (arr && arr.steps && arr.steps.length > 0
        && parseInt(arr.steps[0].stepTypeId, 10) !== 3
        && (arr.steps[0].answers || (arr.steps[0].answers
        && arr.steps[0].answers.length > 0))
    ) {
      // eslint-disable-next-line no-param-reassign
      delete arr.steps[0].answers;
    }

    if (arr && arr.steps) {
      arr.steps.forEach((step) => {
        if (parseInt(step.stepTypeId, 10) !== StepTypes.Hub) {
          // eslint-disable-next-line no-param-reassign
          delete step.hubOptions;
          // eslint-disable-next-line no-param-reassign
          delete step.hubSettings;
        } else {
          // Serialize hub data to match v3 API contract.
          // The global replacer strips empty arrays (mods, tags), so restore them here.
          if (step.hubSettings) {
            // eslint-disable-next-line no-param-reassign
            delete step.hubSettings.id;
            // eslint-disable-next-line no-param-reassign
            delete step.hubSettings.stepId;
            prepareHubSettingsForSave(step.hubSettings);
          }
          if (step.hubOptions) {
            step.hubOptions.forEach((opt) => {
              prepareHubOptionForSave(opt);
            });
          }
        }
      });
    }

    // Must run after prepareHubOptionForSave — it rebuilds opt.mods from scratch.
    enrichArrWithBranchTitles(
      arr,
      globalContext?.memories ?? [],
      collectExistingTitles(globalContext?.branches, data, arr),
    );

    if (validated === true) {
      if (data !== null && data.id) {
        onLocationSelected(arr.locationId || null);
        this.setState({
          saveLoading: true,
        });
        api.put(`/v1/stories/${storyId}/branches/${data.id}`, arr)
          .then(() => {
            onBranchUpdate(data.id);
            this.setState({
              saveLoading: false,
            });
          })
          .catch((error) => {
            this.errorAlert(error);
            this.setState({
              saveLoading: false,
            });
          });
      } else {
        this.setState({
          addLoading: true,
        });
        if (!arr.locationId && lastLocation) {
          // eslint-disable-next-line no-param-reassign
          arr.locationId = lastLocation;
        }
        api.post(`/v1/stories/${storyId}/branches`, arr)
          .then((res) => {
            localStorage.setItem(`lastEdit-${storyId}`, res.data.branch.id);
            onBranchCreate({ id: res.data.branch.id, arr });
          })
          .catch((error) => {
            this.setState({
              addLoading: false,
            });
            if ((data === null || !data.id) && onError) {
              onError(error);
              update();
            } else {
              this.errorAlert(error);
            }
          });
      }
    }
  }

  updateLive(arr, validated) {
    const { globalContext, data } = this.props;
    // eslint-disable-next-line no-param-reassign
    arr = JSON.parse(JSON.stringify(arr, replacer, 2));

    enrichArrWithBranchTitles(
      arr,
      globalContext?.memories ?? [],
      collectExistingTitles(globalContext?.branches, data, arr),
    );

    if (validated === true) {
      this.setState({
        saveLoading: true,
      });
      const { update, storyId, edit } = this.props;
      const putUrl = `/v1/stories/${storyId}/branches/${data.id}/live`;
      api.put(putUrl, arr)
        .then(() => {
          update();
          edit(false);
          // `onHide` closes over AddBranchEdit from its own render, so it must be read
          // only after `edit(false)` above — reading it earlier would carry the pre-save
          // (dirty) closure and pop the confirmation dialog instead of closing directly.
          const { onHide } = this.props;
          onHide();
          this.setState({
            saveLoading: false,
          });
        })
        .catch((error) => {
          this.errorAlert(error);
          this.setState({
            saveLoading: false,
          });
        });
    }
  }

  formSlotValidate = (slotValue, slotId, actionType) => {
    const { memoryBank } = this.props;

    const foundSlot = memoryBank.find((slot) => slot.id === Number(slotId));
    const memoryLinkValue = getMemorySlotVariableLink(slotValue);

    if (memoryLinkValue) {
      const { type, variableId } = memoryLinkValue;
      switch (type) {
        case MemoryCheckValueType.Variable: {
          const comparedVariable = memoryBank.find((memory) => memory.id === Number(variableId));
          if (!comparedVariable) {
            showToast({ textMessage: 'Compared variable not found' });
            return false;
          }
          if (!foundSlot) {
            showToast({ textMessage: `Memory with id ${slotId} not found` });
            return false;
          }
          const isComparedVariableTypeValid = comparedVariable && comparedVariable.type === foundSlot.type;
          if (!isComparedVariableTypeValid) {
            showToast({ textMessage: `Slot value type is not valid in ${comparedVariable?.name}` });
            return false;
          }
          break;
        }
        case MemoryCheckValueType.VariableArray: {
          if (!Array.isArray(variableId)) {
            showToast({ textMessage: 'Variable array should be an array' });
            return false;
          }
          if (variableId.length < 2) {
            showToast({ textMessage: 'Variable array should have at least TWO element' });
            return false;
          }
          break;
        }
        default:
          break;
      }
      return true;
    }

    if (!foundSlot) {
      showToast({ textMessage: `Memory with id ${slotId} not found` });
      return false;
    }

    if (actionType === BranchStepMemoryActionType.View) {
      const availableActionTypes = Object.values(BranchStepMemoryActionType);
      if (foundSlot.showIn.length === 0) {
        showToast({ textMessage: `Memory visibility disabled in Memory Bank for ${foundSlot.name}` });
        return false;
      }
      return availableActionTypes.includes(actionType);
    }

    if (foundSlot.type === MemoryType.Number) {
      const isNumbersOnly = /^-?\d+$/.test(slotValue);
      if (!isNumbersOnly) {
        showToast({ textMessage: 'Value should be a number' });
      }
      return isNumbersOnly;
    }

    if (!slotValue.match(/^[\w\d]+[\w\d _.-]*$/)) {
      showToast({
        textMessage: 'Slot value should contain only letters, numbers, spaces, and "_", ".", "-" and should start with a letter or number',
        timeout: 7000,
      });
      return false;
    }
    return true;
  };

  formActionValidate = (stepObj) => {
    const { action } = stepObj;

    if (!action.value) {
      showToast({
        textMessage: 'Value field should not be empty',
      });
      return false;
    }

    const memoryLink = getMemorySlotVariableLink(action.value);
    if (memoryLink && !memoryLink.variableId) {
      showToast({
        textMessage: 'Please select a memory variable',
      });
      return false;
    }

    const isSlotValid = this.formSlotValidate(action.value, action.variableId, action.type);
    return isSlotValid;
  };

  formRollValidate = (stepObj) => {
    const { roll } = stepObj;

    // Handle different roll types
    if (roll.type === BranchStepMemoryRollType.Dice) {
      // For DICE type, dice notation is optional (can be set later)
      // But if provided, it must be valid
      if (roll.diceNotation && roll.diceNotation.trim() !== '') {
        try {
          const diceRoll = new DiceRoll(roll.diceNotation);

          // Additional validation for reasonable limits
          const notation = roll.diceNotation.trim();
          const diceMatch = notation.match(/(\d+)d(\d+)/g);
          if (diceMatch) {
            for (const dice of diceMatch) {
              const [numDice, diceSides] = dice.split('d').map(num => parseInt(num, 10));
              if (numDice > 100) {
                showToast({
                  textMessage: 'Too many dice in a single roll (max 100 per die type)',
                });
                return false;
              }
              if (diceSides > 120) {
                showToast({
                  textMessage: 'Too many sides per die (max 120)',
                });
                return false;
              }
            }
          }
        } catch (error) {
          showToast({
            textMessage: `Invalid dice notation: ${error.message}`,
          });
          return false;
        }
      }

      return true;
    } else {
      // Validate other types (SET, INCREASE, DECREASE - use min and max)
      // Min/max are optional (can be empty for later configuration)
      // But if provided, they must be valid

      const hasMin = roll.min !== undefined && roll.min !== null && roll.min !== '';
      const hasMax = roll.max !== undefined && roll.max !== null && roll.max !== '';

      if (hasMin) {
        const minNum = Number(roll.min);
        if (isNaN(minNum) || !Number.isInteger(minNum)) {
          showToast({
            textMessage: 'Min value must be an integer',
          });
          return false;
        }
      }

      if (hasMax) {
        const maxNum = Number(roll.max);
        if (isNaN(maxNum) || !Number.isInteger(maxNum)) {
          showToast({
            textMessage: 'Max value must be an integer',
          });
          return false;
        }
      }

      // Only validate min <= max if both are provided
      if (hasMin && hasMax) {
        const minNum = Number(roll.min);
        const maxNum = Number(roll.max);
        if (minNum > maxNum) {
          showToast({
            textMessage: 'Min value cannot be greater than Max value',
          });
          return false;
        }
      }

      // Validate modifier if present (must be integer)
      if (roll.modifier !== undefined && roll.modifier !== '') {
        const modifierValue = Number(roll.modifier);
        if (isNaN(modifierValue) || !Number.isInteger(modifierValue)) {
          showToast({
            textMessage: 'Modifier must be an integer',
          });
          return false;
        }
      }

      // Note: formSlotValidate expects action types, not roll types, so we skip it for roll validation
      // The numeric validation above is sufficient for roll fields
      return true;
    }
  };

  formSwitchValidate = (stepObj) => {
    const checkOperator = stepObj?.check?.operator;
    if (!checkOperator) {
      showToast({ textMessage: 'Check operator is empty' });
      return false;
    }

    const operator = CheckOperator[checkOperator];
    const isConditionList = operator?.isConditionList ?? false;

    // For normal checks, should have 2 cases. For multi-select/condition-list, can have more
    if (stepObj.switch.length !== 2 && operator?.isMultiSelect !== true && !isConditionList) {
      showToast({ textMessage: 'Switch should have 2 cases' });
      return false;
    }

    // For ConditionList, validate at least 2 conditions
    if (isConditionList && stepObj.switch.length < 2) {
      showToast({ textMessage: 'Condition List should have at least 2 conditions' });
      return false;
    }

    // For ConditionList, validate max 11 conditions
    if (isConditionList && stepObj.switch.length > 11) {
      showToast({ textMessage: 'Condition List cannot have more than 11 conditions' });
      return false;
    }

    let isValid = true;
    stepObj.switch.forEach((switchObj) => {
      if (!switchObj.gotoBranchId) {
        showToast({
          textMessage: 'Goto branch is empty',
        });
        isValid = false;
      }
    });
    return isValid;
  };

  formCheckValidate = (stepObj) => {
    console.error("formCheckValidate = "+JSON.stringify(stepObj,null,2));
    if (!stepObj.check.operator) {
      showToast({ textMessage: 'Check operator is empty' });
      return false;
    }
    const isMultiSelect = CheckOperator[stepObj.check.operator]?.isMultiSelect ?? false;
    const isConditionList = CheckOperator[stepObj.check.operator]?.isConditionList ?? false;
    const isPlayerHas = CheckOperator[stepObj.check.operator]?.isPlayerHas ?? false;

    if (isMultiSelect) {
      if (!stepObj.switch || stepObj.switch.length < 2) {
        showToast({ textMessage: 'At least 2 memory options must be selected' });
        return false;
      }
    } else if (!isPlayerHas && !stepObj.check.variableId) {
      showToast({ textMessage: 'Check variable is empty' });
      return false;
    }

    // For ConditionList and PlayerHas, there's no value field to validate, just return true
    if (isConditionList || isPlayerHas) {
      return true;
    }

    return this.formSlotValidate(
      stepObj.check.value,
      stepObj.check.variableId,
    );
  };

  formAnswerRequirementsValidate = (answersList) => {
    const { user } = this.props;
    let isSlotValid = true;
    let numOfRequirements = 0;
    const numOfAnswers = answersList.length;

    answersList.forEach((answer) => {
      if (answer.requirement && answer.requirement.check) {
        numOfRequirements += 1;

        // check if comparing value is ok
        const isAnswerSlotValid = this.formSlotValidate(
          answer.requirement.check.value,
          answer.requirement.check.variableId,
        );

        if (!isAnswerSlotValid) {
          isSlotValid = false;
        }
      }
    });

    if (!isSlotValid) {
      showToast({ textMessage: 'Requirements parameters are invalid' });
    }

    const isAdmin = user && user.role === 'admin';
    // prevent having all answers with requirements (one needs to be always visible);
    const isAnswerWithoutRequirement = !(numOfRequirements === numOfAnswers) || isAdmin;
    if (!isAnswerWithoutRequirement) {
      showToast({ textMessage: 'No Free Answer without Requirements' });
    }

    return isSlotValid && isAnswerWithoutRequirement;
  };

  formValidated = (validateValue) => {
    const { locationId, locations, stepsType } = this.state;
    const { limits, memoryBank, answerTypes: answerType } = this.props;
    const {
      steps,
      stepTypeMode,
      title,
      description,
    } = validateValue;

    // Create lookup map for O(1) answer type checks
    const answerTypeById = new Map(answerType?.map((t) => [t.id, t]) ?? []);
    const isEliminationType = stepTypeMode === StepTypeMode.Elimination;
    const isChoiceStep = isDecisionStep(validateValue);
    const hasSteps = steps && steps.length > 0;

    if (hasNewBackgroundDataRow(steps, this.state.stepConst)) {
      return false;
    }

    if (title && (title.length > Number(limits.branch_title_max.value))) {
      showToast({ textMessage: `Title is too long. Max length is ${limits.branch_title_max.value} characters` });
      return false;
    }

    if (description && (description.length > Number(limits.branch_description_max.value))) {
      showToast({ textMessage: `Description is too long. Max length is ${limits.branch_description_max.value} characters` });
      return false;
    }

    if (!hasSteps) {
      // Request from Jess. Allow save w/o steps
      return true;
    }

    const hasAnswers = steps.some((step) => step.answers && step.answers.length > 0);
    if (!hasAnswers && isChoiceStep) {
      showToast({ textMessage: 'No answers in the step' });
      return false;
    }

    // Check for correct answers in Elimination Mode
    if (isEliminationType) {
      for (let i = 0; i < steps.length; i++) {
        const step = steps[i];
        const { answers } = step;
        if (!answers) {
          showToast({ textMessage: 'No Answers in Elimination Mode' });
          return false;
        }
        const isCorrectAnswerExist = answers.some((answer) => answer.eliminationResultType === EliminationAnswerResultType.Correct);
        if (!isCorrectAnswerExist) {
          showToast({ textMessage: 'No Correct Answer in Elimination Mode' });
          return false;
        }
      }
    }

    // Check if using Video location with Video step
    const selectedLocationId = validateValue.locationId || locationId;
    const hasVideoStep = steps.some((step) => Number(step.stepTypeId) === StepTypes.Video);
    if (hasVideoStep) {
      const willDefaultLocation = !selectedLocationId || selectedLocationId === '0';
      const defaultLocation = locations.find((location) => location.isDefault);
      const currentLocation = willDefaultLocation
        ? defaultLocation
        : locations.find((location) => Number(location.id) === Number(selectedLocationId));
      if (currentLocation?.videoId) {
        showToast({ textMessage: 'Cannot use a Video Step Type with a Video Location selected. Please choose one or the other.' });
        return false;
      }
    }

    // A node with any Video step cannot use a video-backed location as the
    // background on any step. The check above only inspects the NODE's location,
    // so this covers per-step values arriving from the legacy Data table, a
    // retype, or an import.
    //
    // PHASE B: the node-level location guard above and this node-wide per-step
    // rule are one decision. Relax them together in the same gated change, never
    // independently.
    const videoBackgroundConflicts = findVideoBackgroundConflicts(
      steps,
      locations,
      StepTypes.Video,
    );
    if (videoBackgroundConflicts.length > 0) {
      videoBackgroundConflicts.forEach((conflict) => {
        const where = describeStep(stepsType, conflict.stepTypeId, conflict.stepIndex);
        showToast({
          textMessage: `${where}: this node has a Video step, so no step can use the video location "${conflict.locationTitle ?? conflict.alias}" as its background. Please choose an image location or clear the step background.`,
        });
      });
      return false;
    }

    // Not a blocker, but the author needs to know: the runtime resolves this
    // alias against the published scenes map without a presence guard, so a
    // background naming a location that no longer exists fails at play time
    // rather than falling back to the node location.
    findUnresolvedBackgrounds(steps, locations).forEach((issue) => {
      const where = describeStep(stepsType, issue.stepTypeId, issue.stepIndex);
      showToast({
        textMessage: `${where}: legacy background "${issue.alias}" is unresolved or conflicting. It is kept unchanged and does not block saving.`,
        variant: 'warning',
        timeout: 7000,
      });
    });

    for (let i = 0; i < steps.length; i++) {
      const step = steps[i];
      if (!step) {
        showToast({ textMessage: `Incorrect data in step ${i}` });
        return false;
      }
      const stepTypeId = Number(step.stepTypeId);

      if (step.text?.length > Number(limits[`step_${stepTypeId}_text_max`]?.value)) {
        showToast({ textMessage: `Step text is too long. Max length is ${limits[`step_${stepTypeId}_text_max`]?.value} characters` });
        return false;
      }

      const errorsInStepText = checkUsedMemoriesInText(step.text ?? '', memoryBank);
      if (errorsInStepText.length > 0) {
        showToast({
          textMessage: `Memory slot(s) ${errorsInStepText.join(', ')} used in the text are not defined in the Memory Bank`,
          variant: 'warning',
          timeout: 7000,
        });
        return false;
      }

      if (step.answers && step.answers.length > 0) {
        for (let j = 0; j < step.answers.length; j++) {
          const answer = step.answers[j];
          if (answer.text && answer.text.length > Number(limits.answer_text_max.value)) {
            showToast({ textMessage: `Answer text is too long. Max length is ${limits.answer_text_max.value} characters` });
            return false;
          }
          if (answer.data && answer.data.length > 0) {
            for (let k = 0; k < answer.data.length; k++) {
              const data = answer.data[k];
              if (data.key && data.key.length > Number(limits.data_key_max.value)) {
                showToast({ textMessage: `Data key is too long. Max length is ${limits.data_key_max.value} characters` });
                return false;
              }
              if (data.value && data.value.length > Number(limits.data_value_max.value)) {
                showToast({ textMessage: `Data value is too long. Max length is ${limits.data_value_max.value} characters` });
                return false;
              }
            }
          }

          const errorsInAnswerText = checkUsedMemoriesInText(answer.text ?? '', memoryBank);
          if (errorsInAnswerText.length > 0) {
            showToast({
              textMessage: `Memory slot(s) ${errorsInAnswerText.join(', ')} used in the answer text are not defined in the Memory Bank`,
              variant: 'warning',
              timeout: 7000,
            });
            return false;
          }

          /* Alternate Prices Validation */
          if (answer.alternatePrices?.length) {
            for (let k = 0; k < answer.alternatePrices.length; k++) {
              const { achievementId, answerPrice } = answer.alternatePrices[k];
              if (Number.isNaN(achievementId) || achievementId <= 0) {
                showToast({ textMessage: `Achievement is not selected in alternate price ${k + 1} in step ${i}` });
                return false;
              }
              if (Number.isNaN(answerPrice) || answerPrice < 0) {
                showToast({ textMessage: `Answer price should be a positive number in alternate price ${k + 1} in step ${i}` });
                return false;
              }
              if (Number(answerPrice) >= Number(answer.answerPrice)) {
                showToast({ textMessage: `Answer price should be less than the main price in alternate price ${k + 1} in step ${i}` });
                return false;
              }
            }
          }

          /* Auto Achieve Validation */
          if (answer.autoAchievements?.length) {
            for (let k = 0; k < answer.autoAchievements.length; k++) {
              const achievement = answer.autoAchievements[k];
              if (Number.isNaN(achievement) || achievement <= 0) {
                showToast({ textMessage: `Achievement is not selected in auto achieve ${k + 1} in step ${i}` });
                return false;
              }
            }
          }

          /* Paid Choice with Disable Requirement Validation */
          if (answer.requirement?.visualTreatmentIfNotMet === 'Disable') {
            const currentAnswerType = answerTypeById.get(parseInt(answer.answerTypeId, 10));
            if (currentAnswerType?.value !== 'passive') {
              showToast({ textMessage: 'Paid choices cannot be disabled by a requirement' });
              return false;
            }
          }
        }

        if (!this.formAnswerRequirementsValidate(step.answers)) {
          return false;
        }
      }

      if (step.data && step.data.length > 0) {
        for (let k = 0; k < step.data.length; k++) {
          const data = step.data[k];
          if (data.key && data.key.length > Number(limits.data_key_max.value)) {
            showToast({ textMessage: `Data key is too long. Max length is ${limits.data_key_max.value} characters` });
            return false;
          }
          if (data.value && data.value.length > Number(limits.data_value_max.value)) {
            showToast({ textMessage: `Data value is too long. Max length is ${limits.data_value_max.value} characters` });
            return false;
          }
        }
      }
      if (step.action && !this.formActionValidate(step)) {
        return false;
      }
      if (step.roll && !this.formRollValidate(step)) {
        return false;
      }
      if (step.switch && !this.formSwitchValidate(step)) {
        return false;
      }
      if (step.check && !this.formCheckValidate(step)) {
        return false;
      }

      if (stepTypeId === StepTypes.Achieve && !step?.achievementId) {
        showToast({ textMessage: `Achievement is not selected in step ${i}` });
        return false;
      }

      if (stepTypeId === StepTypes.Hub) {
        const hubValidation = validateHubStep(step);
        if (!hubValidation.valid) {
          showToast({ textMessage: hubValidation.errors[0] });
          return false;
        }
        if (hubValidation.warnings.length > 0) {
          hubValidation.warnings.forEach((w) => showToast({ textMessage: w }));
        }
      }
    }

    return true;
  };

  handleSubmit(event) {
    const { restrictedEdit, globalContext } = this.props;

    event.preventDefault();
    const form = event.currentTarget;
    const validated = form.checkValidity();
    // Payload source of truth: serialize() reads from the form DOM, which for
    // every meaningful field mirrors React controlled state (DOM ≡ state).
    // disabled:false ensures CustomSelect's hidden inputs (e.g. gotoBranchId)
    // are included even when visually disabled. Hub data (hubSettings/hubOptions)
    // is merged from this.state.steps[i] below — Hub renders no hidden inputs.
    // Therefore the side-panel feature (R2) needs no separate "build payload from
    // state" branch here — the serialized payload already equals the state
    // projection. R2 will replace serialize() with a direct state read when the
    // form is rewritten; for R1 there is no behavioural fork.
    const formValues = serialize(form, { hash: true, disabled: false });

    const { achievements: achievementsProvider } = globalContext;
    const gamePassAchievement = achievementsProvider?.achievements?.find((achievement) => isGamePassAchievement(achievement));

    // We need pass '*.value' as object but forms don't support values as objects
    // Here we change '*.value' to object
    formValues.steps = formValues?.steps?.map((step) => {
      const newStep = { ...step };
      if (newStep.check) {
        // For playerHas, parse the JSON array string back to an array
        if (newStep.check.operator === 'playerHas' && typeof newStep.check.value === 'string') {
          try {
            newStep.check.value = JSON.parse(newStep.check.value);
          } catch (e) {
            newStep.check.value = [];
          }
          return newStep;
        }

        const newValue = isMemorySlotVariableLink(newStep.check.value)
          ? parseMemorySlotVariableLink(newStep.check.value)
          : newStep.check.value;
        if (newValue) {
          newStep.check.value = newValue;
          return newStep;
        }
      }

      if (newStep.answers) {
        newStep.answers = newStep.answers.map((answer) => {
          const newAnswer = { ...answer };

          // Cleanup alternate prices for new answers with 0 price
          if (!newAnswer.id && (!newAnswer.answerPrice || Number(newAnswer.answerPrice) <= 0)) {
            if (newAnswer.alternatePrices) {
              newAnswer.alternatePrices = newAnswer.alternatePrices.filter(
                (alternatePrice) => Number(alternatePrice.achievementId) !== Number(gamePassAchievement?.id),
              );
            }
          }

          if (newAnswer.requirement?.isBadgeHidden !== undefined) {
            newAnswer.requirement.isBadgeHidden = newAnswer.requirement.isBadgeHidden === 'true';
          }
          if (newAnswer.requirement?.check?.value !== undefined) {
            const newValue = isMemorySlotVariableLink(newAnswer.requirement.check.value)
              ? parseMemorySlotVariableLink(newAnswer.requirement.check.value)
              : newAnswer.requirement.check.value;
            if (newValue) {
              newAnswer.requirement.check.value = newValue;
              return newAnswer;
            }
          }
          const { data } = newAnswer;
          if (data) {
            newAnswer.data = data.map((currentData) => {
              const currentNewUsersOnly = currentData.newUsersOnly;
              const newUsersOnly = currentNewUsersOnly === 'on';
              return { ...currentData, newUsersOnly };
            });
          }
          return newAnswer;
        });
      }

      const { data } = newStep;
      if (data) {
        newStep.data = data.map((currentData) => {
          const currentNewUsersOnly = currentData.newUsersOnly;
          const newUsersOnly = currentNewUsersOnly === 'on';
          return { ...currentData, newUsersOnly };
        });
      }

      // Parse action value from serialized string to MemoryLinkValue object
      if (newStep.action && isMemorySlotVariableLink(newStep.action.value)) {
        newStep.action.value = parseMemorySlotVariableLink(newStep.action.value);
      }

      // Convert action string value to array
      if (newStep.action && newStep.action.type === RememberActionType.VIEW.name) {
        const newActionValue = newStep.action.value?.split(',') ?? [MemoryShowIn.Hide];
        if (newActionValue) {
          newStep.action.value = newActionValue;
          return newStep;
        }
        showToast({ textMessage: 'Error parsing action value' });
      }

      if (newStep.stepAudios) {
        try {
          newStep.stepAudios = JSON.parse(newStep.stepAudios);
        } catch (e) {
          showToast({ textMessage: 'Error parsing stepAudios' });
          delete newStep.stepAudios;
        }
      }

      if (newStep.video?.videoSettings) {
        try {
          newStep.video.videoSettings = JSON.parse(newStep.video.videoSettings);
        } catch (e) {
          showToast({ textMessage: 'Error parsing video settings' });
          delete newStep.video.videoSettings;
        }
      }

      return newStep;
    });
    // Hub step data lives in React state, not in form inputs — merge it back
    if (formValues.steps && this.state.steps) {
      formValues.steps = formValues.steps.map((formStep, i) => {
        const stateStep = this.state.steps[i];
        if (stateStep && Number(stateStep.stepTypeId) === StepTypes.Hub) {
          return { ...formStep, hubSettings: stateStep.hubSettings ?? { header: { text: '' }, subheader: null }, hubOptions: stateStep.hubOptions };
        }
        return formStep;
      });
    }

    // Same problem, different field: a step type whose StepType.fields list omits
    // "text" renders no text input, so serialize() produces no `text` key for it.
    // The save path then destroys the step row and recreates it from the payload,
    // so the existing text is dropped rather than preserved. Restore it from the
    // pristine loaded copy (stepConst), joined by step id, but only for steps
    // whose type has not changed — retyping into a no-text type is a deliberate
    // clear, which is what edit_context does on the same transition.
    formValues.steps = mergeStepBackgrounds(formValues.steps, this.state.steps);
    formValues.steps = preserveUnrenderedStepText(
      formValues.steps,
      this.state.steps,
      this.state.stepsType,
      this.state.stepConst,
    );

    if (validated === false) {
      // Bootstrap renders per-field feedback only once the form is marked
      // validated, and formValidated() (which owns the toasts) is never reached
      // on this path — so without both of these the Save button silently does
      // nothing and the author has no way to see which field is at fault.
      this.setState({ validated: true });
      showToast({
        textMessage: 'Some required fields are empty or invalid. Please check the highlighted fields.',
      });
      const firstInvalid = form.querySelector(':invalid');
      if (firstInvalid) {
        firstInvalid.scrollIntoView({ block: 'center', behavior: 'smooth' });
        if (typeof firstInvalid.focus === 'function') {
          firstInvalid.focus({ preventScroll: true });
        }
      }
      event.stopPropagation();
      return;
    }

    if (!this.formValidated(formValues)) {
      event.stopPropagation();
      return;
    }

    if (restrictedEdit) {
      this.updateLive(formValues, validated);
    } else {
      this.addStories(formValues, validated);
    }
    this.setState({ validated: true });
    event.stopPropagation();
  }

  getCheckChoiceStates(steps) {
    return {
      choice: isStepTypeIdExist(steps, StepTypes.Choice),
      isCheckStep: isStepTypeIdExist(steps, StepTypes.Check),
      isHubStep: isStepTypeIdExist(steps, StepTypes.Hub),
      ending: isStepTypeIdExist(steps, StepTypes.Ending),
      result: isStepTypeIdExist(steps, StepTypes.Result),
    };
  }

  pasteStep = () => {
    const { result, steps, ending } = this.state;

    const data = getStepData();
    if (data.length < 1) {
      return;
    }
    data.forEach((a) => {
      const obj = prepareForCopy(a);

      if ((Number(obj.stepTypeId) === 3) && (steps.length > 0)) {
        this.errorAlert({ response: { data: { error: 'Choice step should be the only one in the node' } } });
        return;
      }
      if ((Number(obj.stepTypeId) === 5 || Number(obj.stepTypeId) === 6) && (!ending && !result)) {
        this.errorAlert({ response: { data: { error: 'Outro/ending node must only have Ending steps' } } });
        return;
      }
      if ((Number(obj.stepTypeId) !== 5 && Number(obj.stepTypeId) !== 6) && (ending || result)) {
        this.errorAlert({ response: { data: { error: 'Outro/ending node must only have Ending steps' } } });
        return;
      }
      setTimeout(() => {
        this.addStep(undefined, obj, false);
      }, 100);
    });
  };

  handleChangeStepTypeMode = (value) => {
    this.setState({ stepTypeMode: value });
  };

  render() {
    const {
      user,
      disabled,
      show,
      limits,
      restrictedEdit,
      modeEdit,
      onHide,
      data: dataFromProps,
      storyId,
      branchesGroup,
      branch,
      story,
      memoryBank,
      onBackgroundsChanged,
      sidePanel,
      answerTypes: answerType,
      modifierTypes: modifiersTypes,
      requiresTypes,
      traitsTypes,
      cursorEvents,
    } = this.props;
    const {
      validated,
      gotoBranchId,
      editHeader,
      stepsType,
      copyStep,
      data,
      saveLoading,
      activeSteps,
      characters,
      currStatsInfo,
      errorMsg,
      deleteStep,
      tagsTypes,
      modalPrev,
      locations,
      ending,
      result,
      SelectStepsDelete,
      locationId,
      modalNext,
      characterExpression,
      addLoading,
      loading,
      disabledSortable,
      defaultValueDescription,
      choice,
      isCheckStep,
      isHubStep,
      steps,
      SelectStepsCopy,
      allCopyStepChecked,
      defaultValueTitle,
      allDeleteStepChecked,
      stepTypeMode,
      audioPath,
    } = this.state;

    if (addLoading === true) {
      return null;
    }

    const sharedSpinner = (
      <Spinner
        animation="border"
        variant="primary"
        className={loading !== false ? 'loadingSpinner justify-content-center' : 'd-none '}
      />
    );

    const sharedPrevNav = (
      <BranchModalPrevNext
        {...this.props}
        storyId={storyId}
        data={data}
        type="prev"
        characterExpression={characterExpression}
        characters={characters}
        actionEditBranch={this.actionEditBranch}
        initEditBranch={this.initEditBranch}
      />
    );

    const sharedNextNav = (
      <BranchModalPrevNext
        {...this.props}
        storyId={storyId}
        data={data}
        type="next"
        characterExpression={characterExpression}
        characters={characters}
        actionEditBranch={this.actionEditBranch}
        initEditBranch={this.initEditBranch}
      />
    );

    // sharedBody holds the Form + all step content — identical for both shells
    const sharedBody = (
      // eslint-disable-next-line react/jsx-indent
            <Form
              ref={this.formRef}
              noValidate
              validated={validated}
              onSubmit={(e) => {
                if (!disabled || restrictedEdit) {
                  this.handleSubmit(e);
                }
              }}
              className={cs('sf-modal', loading !== false ? 'd-none' : null)}
            >

              <div className="sf-container">
                <AddBranchHead
                  user={user}
                  title={defaultValueTitle}
                  disabled={!!(saveLoading || disabled)}
                  description={defaultValueDescription}
                  storyId={storyId}
                  story={story}
                  locationId={locationId}
                  onLocationChange={(id) => {
                    this.setState({ locationId: id });
                    cursorEvents?.nodeEdited({ locationId: id });
                  }}
                  locations={locations}
                  limits={limits}
                  activeStepsFunc={this.activeSteps}
                  editHeader={editHeader}
                  updateLocation={this.updateLocation}
                  update={(e) => {
                    this.setState({
                      editHeader: e,
                    });
                  }}
                  restrictedEdit={restrictedEdit}
                  onBackgroundsChanged={onBackgroundsChanged}
                />

                <div
                  id={SCROLLABLE_STEP_FORM_ELEMENT_ID}
                  className="sf-content"
                >
                  <Form.Check
                    id="step-type-mode"
                    name="stepTypeMode"
                    type="hidden"
                    value={stepTypeMode ?? StepTypeMode.Regular}
                  />

                  {SelectStepsCopy && (
                    // eslint-disable-next-line max-len
                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                    <div
                      onClick={(e) => {
                        this.setState({
                          allCopyStepChecked: !allCopyStepChecked,
                        });
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                      style={{
                        width: '15em',
                        marginLeft: '1.55em',
                      }}
                    >
                      <Form.Check
                        custom
                        autoFocus
                        as="input"
                        checked={allCopyStepChecked}
                        onMouseOver={(e) => {
                          this.disabledSortableAction(e);
                        }}
                        onChange={
                          (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                          }
                        }
                        type="checkbox"
                        id="allCopyStep"
                        name="allCopyStep"
                        label="Select All Steps to Copy"
                        style={{ margin: '.25em' }}
                      />
                    </div>
                  )}

                  {SelectStepsDelete && (
                  // eslint-disable-next-line max-len
                  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                    <div
                      onClick={(e) => {
                        const all = !allDeleteStepChecked;
                        const newDeleteStep = [];
                        if (all) {
                          steps.map((a, i) => newDeleteStep.push(i));
                        }
                        this.setState({
                          deleteStep: newDeleteStep,
                          allDeleteStepChecked: all,
                        });
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                      style={{
                        width: '15em',
                        marginLeft: '1.55em',
                      }}
                    >
                      <Form.Check
                        custom
                        autoFocus
                        as="input"
                        checked={allDeleteStepChecked}
                        onMouseOver={(e) => {
                          this.disabledSortableAction(e);
                        }}
                        onChange={
                          (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                          }
                        }
                        type="checkbox"
                        id="allDeleteStep"
                        name="allDeleteStep"
                        label="Select All Steps to Delete"
                        style={{ margin: '.25em' }}
                      />
                    </div>
                  )}
                  { !loading && (
                    <ContextProvider
                      branches={branch}
                      currentBranchId={dataFromProps.id}
                      characterExpression={characterExpression}
                      tagsTypes={tagsTypes}
                      modifiersTypes={modifiersTypes}
                      characters={characters}
                      stepsType={stepsType}
                      requiresTypes={requiresTypes}
                      traitsTypes={traitsTypes}
                      answerType={answerType}
                      currStatsInfo={currStatsInfo}
                      storyRecommendations={story.recommendations}
                      memoryBankSlots={memoryBank}
                      limits={limits}
                      stepTypeMode={stepTypeMode}
                      handleChangeStepTypeMode={this.handleChangeStepTypeMode}
                      story={story}
                      restrictedEdit={restrictedEdit}
                      modeEdit={modeEdit}
                    >
                      <SortableListSteps
                        distance={2}
                        user={user}
                        items={steps}
                        nodeSteps={steps}
                        limits={limits}
                        locations={locations}
                        disabledSortable={disabledSortable || restrictedEdit || choice || isCheckStep || isHubStep}
                        disabledSortableAction={this.disabledSortableAction}
                        onSortEnd={this.onSortEnd}
                        helperClass="sort-item"
                        errorAlert={this.errorAlert}
                        story={story}
                        totalSteps={count(steps)}
                        deleteStep={this.deleteStep}
                        addStep={this.addStep}
                        activeSteps={activeSteps}
                        activeStepsFunc={this.activeSteps}
                        onStepFocus={this.props.cursorEvents?.stepFocused}
                        handleChangeSteps={this.handleChangeSteps}
                        updateStep={this.updateSteps}
                        isIntro={dataFromProps && dataFromProps.title === 'intro'}
                        ending={ending}
                        result={result}
                        defStepType={this.defStepType()}
                        updateCharacters={(val) => {
                          this.reLoadCharacters(val);
                        }}
                        copyStep={copyStep}
                        updateCopyStep={(selectedSteps) => {
                          this.setState({
                            copyStep: selectedSteps,
                            allCopyStepChecked: steps.length === selectedSteps.length,
                          });
                        }}
                        updateDeleteStep={(stepIndex, isCheck) => {
                          const newStepIndexesToDelete = isCheck
                            ? [...deleteStep, stepIndex]
                            : deleteStep.filter(
                              (stepIndexToDelete) => stepIndexToDelete !== stepIndex,
                            );
                          this.setState({
                            deleteStep: newStepIndexesToDelete,
                            allDeleteStepChecked: steps.length === newStepIndexesToDelete.length,
                          });
                        }}
                        deleteStepVal={deleteStep}
                        SelectStepsCopy={SelectStepsCopy}
                        SelectStepsDelete={SelectStepsDelete}
                        restrictedEdit={restrictedEdit}
                        allCopyStepChecked={allCopyStepChecked}
                        allDeleteStepChecked={allDeleteStepChecked}
                        branches={branch}
                        addStepAction={this.addStepAction}
                        removeStepAction={this.removeStepAction}
                        handleChangeStepAction={this.handleChangeStepAction}
                        addStepRoll={this.addStepRoll}
                        removeStepRoll={this.removeStepRoll}
                        handleChangeStepRoll={this.handleChangeStepRoll}
                        addStepCheck={this.addStepCheck}
                        removeStepCheck={this.removeStepCheck}
                        handleChangeStepCheck={this.handleChangeStepCheck}
                        handleChangeStepSwitch={this.handleChangeStepSwitch}
                        handleAddStepSwitchCondition={this.handleAddStepSwitchCondition}
                        handleRemoveStepSwitchCondition={this.handleRemoveStepSwitchCondition}
                        handleReorderStepSwitchConditions={this.handleReorderStepSwitchConditions}
                        handleChangeStepSwitchCondition={this.handleChangeStepSwitchCondition}
                        handleChangeStepSwitchVariableCondition={this.handleChangeStepSwitchVariableCondition}
                        audioPath={audioPath}
                      />
                    </ContextProvider>
                  )}

                  <AddStep
                    steps={steps}
                    restrictedEdit={restrictedEdit}
                    choice={choice}
                    isHubStep={isHubStep}
                    addStep={this.addStep}
                    pasteStep={this.pasteStep}
                    copyStep={copyStep}
                    SelectStepsCopy={SelectStepsCopy}
                    updateCopyStep={(val) => {
                      this.setState({
                        copyStep: val,
                      });
                    }}
                    updateDeleteStep={(val) => {
                      this.setState({
                        deleteStep: val,
                      });
                    }}
                    handleAddSteps={() => {
                      clearStepData();
                      this.setState({
                        SelectStepsCopy: !SelectStepsCopy,
                        SelectStepsDelete: false,
                        disabledSortable: false,
                        allCopyStepChecked: false,
                        allDeleteStepChecked: false,
                        deleteStep: [],
                        copyStep: [],
                      });
                    }}
                    SelectStepsDelete={SelectStepsDelete}
                    deleteStep={deleteStep}
                    deleteStepFunc={this.deleteStep}
                    handleDelete={() => {
                      localStorage.setItem('copyStep', JSON.stringify([]));
                      this.setState({
                        SelectStepsCopy: false,
                        SelectStepsDelete: !SelectStepsDelete,
                        disabledSortable: false,
                        allCopyStepChecked: false,
                        allDeleteStepChecked: false,
                        deleteStep: [],
                        copyStep: [],
                      });
                    }}
                    isCheckStep={isCheckStep}
                  />
                </div>

                <div className="sf-footer">
                  <Form.Row className="w-100">
                    <Form.Group as={Col} md="9" className="mb-0 pb-0" controlId="gotoBranchId">
                      <Row>
                        <Form.Label column>
                          {
                            stepTypeMode === StepTypeMode.Regular
                              ? 'Goto node'
                              : 'Goto correct node'
                          }
                        </Form.Label>
                        <Col md={9}>
                          <CustomSelect
                            value={gotoBranchId || ''}
                            disabled={(choice && stepTypeMode === StepTypeMode.Regular)
                              || ending
                              || result
                              || restrictedEdit
                              || isCheckStep
                              || isHubStep}
                            name="gotoBranchId"
                            args={[
                              { id: null, title: '' },
                              { id: -1, title: '[Create New Node]' },
                              ...branch,
                            ]}
                            data={dataFromProps.id}
                            onFocus={noop}
                            onChange={(e) => {
                              this.setState({
                                gotoBranchId: e,
                              });
                            }}
                          />
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group as={Col} className="mb-0 pb-0 text-right">
                      <Button
                        className="mx-1"
                        size="sm"
                        variant="secondary"
                        onClick={() => onHide()}
                      >
                        Cancel
                      </Button>

                      <Button
                        size="sm"
                        type="submit"
                        variant="primary"
                        disabled={
                          !!((
                            saveLoading
                              || disabled
                          )
                            && !restrictedEdit
                          )
                          || !modeEdit
                          || PremiumIpDisabledEdit(user.role, story.book, branchesGroup)
                          || PremiumIpDisabledApprovedEdit(user.role, story.book)
                        }
                      >
                        {saveLoading && (
                          <Spinner
                            variant="primary"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                        {restrictedEdit ? 'Update Live' : 'Save'}
                      </Button>
                    </Form.Group>
                  </Form.Row>
                </div>
              </div>
            </Form>
    );

    if (sidePanel) {
      // Full-width form when the author has hidden the emulator. Source of truth
      // is sessionStorage 'previewPanelSate' (written by StoryBranches on toggle),
      // so no prop drilling — the form reads the author's choice directly.
      // (Typo 'Sate' is intentional — matches the production key.)
      const emulatorHidden = sessionStorage.getItem('previewPanelSate') === 'false';
      return (
        <>
          <ErrorAlert error={errorMsg} close={this.errorAlertClose} />

          <div className={`nodeEditPanel${emulatorHidden ? ' nodeEditPanel--full' : ''}`}>
            {sharedSpinner}

            <div className="mb-0 smf-header">
              {sharedPrevNav}
              {/* Close button — mirrors Modal's closeButton (calls same onHide handler) */}
              <button
                type="button"
                className="close ml-auto"
                aria-label="Close"
                onClick={() => onHide()}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="smf-body">
              {sharedBody}
            </div>

            <div className="smf-footer">
              {sharedNextNav}
            </div>
          </div>
        </>
      );
    }

    return (
      <>
        <ErrorAlert error={errorMsg} close={this.errorAlertClose} />

        <Modal
          show={show}
          onHide={onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          className={cs('modalBig', 'modal-dialog', modalNext === true ? 'modalNext-active' : '', modalPrev ? 'modalPrev-active' : '')}
          centered
          backdrop="static"
          keyboard={false}
        >
          {sharedSpinner}

          <Modal.Header closeButton className="mb-0 smf-header">
            {sharedPrevNav}
          </Modal.Header>

          <Modal.Body className="p-0">
            {sharedBody}
          </Modal.Body>

          <Modal.Footer className="smf-footer">
            {sharedNextNav}
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
